import React, { Component, Fragment } from 'react';
import CommonOrderTable from '../../common/orders/CommonOrderTable';

import style from './manualEntry/manualEntryStyle.module.css';
import commonStyles from '../../common/common.module.css';
import CloseIcon from '@material-ui/icons/Close';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import PickupOrderModel from '../../../models/PickupOrder';

import { Moment } from 'moment';
import { PO_SCHEMA } from '../../../utils/pickupOrder';
import ConfirmationDialog from '../../confirmation/ConfirmationDialog';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import ApiResponse from '../../../models/ApiResponse';
import pickupOrderRemote from '../../../api/pickupOrderRemote';
import ResponseError from '../../../models/ResponseError';
import PickupOrder from '../../../models/PickupOrder';
import { connect } from 'react-redux';
import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

const styles = (theme: Theme) =>

  createStyles({
    btnWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '30px'
    },
    update: {
      width: '200px',
    },
    submitBtn: {
      margin: '10px 16px',
      fontSize: '13px',
    },
    close: {
      fontSize: '27px'
    },
    '@media (max-width:480px)': {
      dialogPaper: {
        margin: '0px',
        width: '90%'
      },
    },
  });

interface EditAirwaybillsComponentProps {
  classes: any;
  selectedOrderNumber: string;
  type: string;
  handleCloseModal: Function;
  modalOpen: boolean;
  receiveError: Function;
  receiveSuccess: Function;
};

interface EditAirwaybillsComponentState {
  pickupOrder: PickupOrderModel;
  editErrors: { pieces: { error: boolean, message: string }, weight: { error: boolean, message: string } };
  // lastAwbDeletionWarning: ((callback: () => void) => void);
  isDeleteLastAwbModalOpened: boolean;
  deleteLastAwbModalCallback: () => void;
};

class EditAirwaybillsComponent extends Component<EditAirwaybillsComponentProps,EditAirwaybillsComponentState > {
    
  state: EditAirwaybillsComponentState = {
    isDeleteLastAwbModalOpened: false,
    deleteLastAwbModalCallback: () => {},
    pickupOrder: PO_SCHEMA,
    editErrors: {
      pieces: { error: false, message: '' },
      weight: { error: false, message: '' }
    },
  }

  componentDidMount(): void {
    pickupOrderRemote.getPickupOrder(this.props.selectedOrderNumber).then((resp: ApiResponse<PickupOrder>) => {

      const pickupOrder: PickupOrder | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (pickupOrder) {


        this.setState({ pickupOrder });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  submitPickupOrder = (): void => {
    const dO: PickupOrderModel = { ...this.state.pickupOrder };

    
    pickupOrderRemote.updatePickupOrder(dO).then((resp: ApiResponse<PickupOrderModel>) => {

      const dO: PickupOrderModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (dO) {

        this.setState({
          pickupOrder: dO
        });

        this.props.receiveSuccess('The DO has been successfully updated!');
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  openLastAwbDeletionWarning = (callback: () => void) => {
    this.setState({isDeleteLastAwbModalOpened: true, deleteLastAwbModalCallback: () => {
      callback();
      this.setState({isDeleteLastAwbModalOpened: false});
    }});
  }

  setContainerState = (data: any): void => {    
    this.setState(data);
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={ this.props.modalOpen }
        onClose={ () => this.props.handleCloseModal('close') }
        aria-labelledby="form-dialog-title"
        maxWidth={ 'lg' }
        disableBackdropClick
        disableEscapeKeyDown
        classes={{ paper: this.props.classes.dialogPaper }}
      >
      <DialogTitle id="form-dialog-title">
      <div className={ style.dialogTitle }>
        <span>Awb Details</span>
        <IconButton aria-label="Close" onClick={ () => this.props.handleCloseModal('close') } className={ classes.close }>
          <CloseIcon color='primary' fontSize='inherit'/>
        </IconButton>
      </div>
     </DialogTitle>
      <DialogContent className={ classes.dialogContent }>
        <div className={ style.orderWrapper }>

          <div className= { commonStyles.headerDummyDiv }> </div>
          <CommonOrderTable 
            pickupOrder={ this.state.pickupOrder }
            setState={ this.setContainerState }
            editErrors={ this.state.editErrors }  
            type={ this.props.type }
            lastAwbDeletionWarning={ this.openLastAwbDeletionWarning }
          />
          { this.state.isDeleteLastAwbModalOpened && 
            <ConfirmationDialog
              open={ this.state.isDeleteLastAwbModalOpened }
              close={ () => { this.setState({ isDeleteLastAwbModalOpened: false }) } }
              title='Delete Confirmation'
              text={`You try to delete the last AWB in this ${this.props.type === 'do' ? 'Drop Off' : 'Pick Up'} Order. \
              If you do this, the ${this.props.type === 'do' ? 'Drop Off' : 'Pick Up'} Order will be marked with status “Deleted”. To confirm deletion, use \
              button “OK”. To cancel, use button “Cancel”.`}
              textConfirm='Ok'
              textCancel='Cancel'
              confirm={ this.state.deleteLastAwbModalCallback } 
              showCloseIcon={ true }
              showCancelButton={ true }
            />
          }
        </div>
      </DialogContent>
      <DialogActions>
        <div className={ classes.btnWrapper}>
          <Button className={ classes.update } onClick={ this.submitPickupOrder } color="primary" variant="contained" >Update</Button>
        </div>
    </DialogActions>
    </Dialog>

    )
  }

}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message))
  };
};

export default  connect(null, mapDispatchToProps)(withStyles(styles)(EditAirwaybillsComponent)); 
